import { Dropdown, Checkbox, Rate } from 'antd'
import { ItemText, Main } from 'components/ActionStyles/ActionStyles'
import AntdAvatar from 'components/Avatar'
import Drawer from 'components/Drawer'
import Flex from 'components/Flex'
import ResumeDownload from 'components/ResumeDownload'
import ResumePreview, { getUploadedCvUrl } from 'components/ResumePreview'
import EmailIcon from 'components/icons/EmailIcon'
import PhoneIcon from 'components/icons/PhoneIcon'
import VerticalThreeDots from 'components/icons/VerticalThreeDots'
import YellowStartIcon from 'components/icons/YellowStartIcon'
import DriveStatus from 'modules/Drives/ViewDriveRole/IndividualDriveTable/DriveStatus/index'
import RoundsSteps from 'modules/Drives/ViewDriveRole/IndividualDriveTable/ViewCandidateInfoDrawer/InterviewDetails/index'
import AIProfileSummaryTab from 'modules/Drives/ViewDriveRole/IndividualDriveTable/ViewCandidateInfoDrawer/AIProfileSummary/AIProfileSummaryTab'
import { getDisplayCriterionText } from 'modules/Drives/ViewDriveRole/IndividualDriveTable/ViewCandidateInfoDrawer/AIProfileSummary/criterionText'
import DownArrowSolid from 'components/icons/DownArrowSolid'
import Button from 'components/Button'
import {
  ContactFlex,
  DropBtn,
  DropDown,
  EmailIdDiv,
  HeaderFlex,
  IconSpan,
  NameDive,
  RatingText,
  RatingsDiv,
  StatusWrapper,
  StyledTab,
  TestDetailsFlex,
  TestFlex,
  ThreeDotsDiv,
  TopFlex,
  TopRightFlex,
  YellowStartSpan,
  AIMatchWrapper,
  ScoreBox,
  Score,
  ScoreLabel,
  Stars,
  MatchContent,
  MatchText,
  CriteriaRow,
  InfoIcon,
  SplitButtonWrapper,
  TooltipBox,
  TooltipItem,
  InfoWrapper,
  GrayCheckbox,
} from 'modules/Drives/ViewDriveRole/IndividualDriveTable/ViewCandidateInfoDrawer/style'
import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import ReactDOMServer from 'react-dom/server'
import MoveToNextRoundTemplate from 'components/EmailTemplate/MoveToNextRoundTemplate'
import RejectionTemplate from 'components/EmailTemplate/RejectionTemplate'
import { sendNotificationBulkEmail, sendNotificationBulkEmailWhatsapp } from 'modules/Users/actions'
import SuccessMessage from 'utils/SuccessMessage'
import ErrorMessage from 'utils/ErrorMessage'
import ResponsesTab from './AIProfileSummary/ResponsesTab '
const { TabPane } = StyledTab

const CandidateInfo = ({
  candidateInfo,
  setCandidateInfo,
  scheduleDrawer,
  setScheduleDrawer,
  candidateDetails,
  rolesMetrics,
  candidateInterviewDetails,
  candidateInfoData,
  updateInterviewStatus,
  driveId,
  roleId,
  getCandidateList,
  selectedRoundType,
  getRoleMetrics,
  setSelectedCandidate,
  setSelectedCandidateId,
  getSingleCandidateInterviewDetails,
  setReleaseOffer,
  singleRoleData,
  stage,
  getNewIndividualDriveStatus,
  setIsModalOpen,
  nextRoundFunction,
  setPopSelectedRound,
  popSelectedRound,
  getDriveRoleMetrics,
}) => {
  const aiMatchData = candidateInfoData?.aiMatchScore
  const aiRecommendation = aiMatchData && (aiMatchData.overall_score || 0) >= 2.5 ? 'shortlist' : 'reject'
  const [selectedAction, setSelectedAction] = useState(aiRecommendation)
  const [isUpdating, setIsUpdating] = useState(false)
  const [showInfo, setShowInfo] = useState(false)
  const dispatch = useDispatch()
  const { userData, corporateData } = useSelector(state => state.auth)

  useEffect(() => {
    if (aiMatchData) {
      const recommendation = (aiMatchData.overall_score || 0) >= 2.5 ? 'shortlist' : 'reject'
      setSelectedAction(recommendation)
    }
  }, [aiMatchData])

  const promotionData = useSelector(state => state?.corporate?.promotionData)

  // Show the CV the candidate uploaded for this role; fall back to the
  // generated system resume only when they never uploaded one.
  const uploadedCvUrl = getUploadedCvUrl(candidateInfoData)
  const candidateFullName =
    `${candidateDetails?.firstName || ''} ${candidateDetails?.lastName || ''}`.trim() ||
    'This candidate'

  // Helper functions to check if actions should be disabled based on candidate status
  const candidateStatus = candidateInfoData?.status
  const offerStatus = candidateInfoData?.offerStatus

  const isShortlistDisabled = () => {
    // Disable shortlist if already shortlisted, absent, or accepted
    return (
      candidateStatus === 'SHORTLISTED' ||
      candidateStatus === 'ABSENT' ||
      candidateStatus === 'ACCEPTED' ||
      candidateInfoData?.isDisabled
    )
  }

  const isRejectDisabled = () => {
    // Disable reject if already rejected or absent
    return (
      candidateStatus === 'REJECTED' ||
      candidateStatus === 'ABSENT' ||
      candidateInfoData?.isDisabled
    )
  }

  const isActionDisabled = () => {
    // Check if current selected action should be disabled
    if (selectedAction === 'shortlist') {
      return isShortlistDisabled()
    }
    return isRejectDisabled()
  }

  const handleMainAction = async () => {
    setIsUpdating(true)
    
    try {
      if (selectedAction === 'shortlist') {
        // For shortlist: Open modal to select next round (same as table behavior)
        nextRoundFunction && nextRoundFunction()
        setIsModalOpen && setIsModalOpen(true)
        // Close the drawer when opening modal
        setCandidateInfo(false)
      } else {
        // For reject: Directly call API to reject the candidate
        const payload = {
          forAllCandidate: false,
          status: 'REJECTED',
          stage: stage === null ? 'all_candidates' : stage,
          studentId: [candidateInfoData?.student?.id],
        }
        
        const response = await getNewIndividualDriveStatus(driveId, roleId, payload, getCandidateList)
        
        if (response?.status >= 200 && response?.status <= 300) {
          SuccessMessage('Candidate rejected successfully')
          getDriveRoleMetrics(driveId)
          getRoleMetrics(driveId, roleId)
          
          // Send rejection email
          const currentRoundName = stage || ''
          const roleName = rolesMetrics?.[0]?.roleName || ''
          const studentEmail = candidateInfoData?.student?.studentPersonalProfile?.primaryEmail
          const studentPhone = candidateInfoData?.student?.studentPersonalProfile?.phoneNumber
          const studentName = candidateInfoData?.student?.firstName || ''
          
          if (studentEmail) {
            const htmlBody = ReactDOMServer.renderToString(
              <RejectionTemplate
                data={{
                  studentName,
                  companyName: corporateData?.name || '',
                  roleName,
                  roundName: currentRoundName,
                  signatureName: (userData?.first_name || '') + (userData?.last_name ? ' ' + userData?.last_name : ''),
                  signatureRole: userData?.role || 'PluginLive',
                }}
              />
            )
            const emailPayload = [{
              to: studentEmail,
              subject: `Update: ${currentRoundName} Status`,
              htmlBody,
            }]
            dispatch(sendNotificationBulkEmail(emailPayload))
          }
          
          // Send rejection WhatsApp
          if (studentPhone) {
            const rejectWaPayload = [{
              to: studentPhone,
              templateName: 'corporate_reject',
              type: 'template',
              components: [
                {
                  type: 'BODY',
                  index: 0,
                  sub_type: 'CATALOG',
                  parameters: [
                    { type: 'TEXT', text: studentName },
                    { type: 'TEXT', text: currentRoundName },
                    { type: 'TEXT', text: roleName },
                    { type: 'TEXT', text: corporateData?.name || '' },
                  ],
                },
              ],
            }]
            dispatch(sendNotificationBulkEmailWhatsapp(rejectWaPayload))
          }
          
          // Close the drawer after successful reject
          setCandidateInfo(false)
          setSelectedCandidate([])
          setSelectedCandidateId([])
        } else {
          ErrorMessage(response?.response?.data?.message || 'Failed to reject candidate')
        }
      }
    } catch (error) {
      ErrorMessage(error?.message || 'An error occurred')
    } finally {
      setIsUpdating(false)
    }
  }

  const handleMenuClick = (e) => {
    if (e.key === 'reject') {
      setSelectedAction('reject')
    } else if (e.key === 'shortlist') {
      setSelectedAction('shortlist')
    }
  }

  const shortlistItems = {
    items: [
      {
        key: selectedAction === 'shortlist' ? 'reject' : 'shortlist',
        label: selectedAction === 'shortlist' ? 'Reject' : 'Shortlist',
      },
    ],
    onClick: handleMenuClick,
  }

  const onClickOffer = () => {
    setReleaseOffer(true)
    setCandidateInfo(false)
  }
  const items = [
    {
      key: 'download',
      label: (
        <ResumeDownload
          triggerButton={<ItemText weight={400}>Download Resume</ItemText>}
          studentDetails={candidateDetails}
          roleId={roleId}
        />
      ),
    },
    candidateInfoData?.status === 'SELECTED' && {
      key: 'upload',
      label: (
        <ItemText weight={400} onClick={onClickOffer}>
          Release Offer
        </ItemText>
      ),
    },
  ]

  const title = () => {

    const aiMatch = candidateInfoData?.aiMatchScore
    const criteriaList = aiMatch?.criteria_scores || []

    const InfoTooltip = () => {
      if (!criteriaList.length) return null

      return (
        <TooltipBox>
          {criteriaList.map((item, index) => (
            <TooltipItem key={index}>
              <GrayCheckbox>
                <Checkbox checked={item.met} readOnly />
              </GrayCheckbox>
              <span>{getDisplayCriterionText(item.text)}</span>
            </TooltipItem>
          ))}
        </TooltipBox>
      )
    }
    return (
      <HeaderFlex column>
        <Flex row spaceBetween centerVertically>
          <TopFlex row centerVertically>
            <AntdAvatar
              size={90}
              src={candidateDetails?.profileUrl}
              IconName={candidateDetails?.firstName?.toUpperCase()?.charAt(0)}
            />
            <ContactFlex column>
              <Flex centerVertically>
                <NameDive>
                  {candidateDetails?.firstName} {candidateDetails?.middelName}{' '}
                  {candidateDetails?.lastName}{' '}
                </NameDive>
                {/* <StatusWrapper>
                <DriveStatus
                  status={candidateInfoData?.status}
                  offerStatus={candidateInfoData?.offerStatus}
                />
              </StatusWrapper> */}
              </Flex>
              {!!candidateDetails?.admin?.email && (
                <EmailIdDiv>
                  <IconSpan>
                    <EmailIcon />
                  </IconSpan>
                  {candidateDetails?.admin?.email}
                </EmailIdDiv>
              )}
              {(
                candidateDetails?.studentPersonalProfile?.phoneNumber ||
                candidateDetails?.admin?.phone_number
              ) && (
                  <EmailIdDiv>
                    <IconSpan>
                      <PhoneIcon />
                    </IconSpan>
                    {candidateDetails?.studentPersonalProfile?.phoneNumber ||
                      candidateDetails?.admin?.phone_number}
                  </EmailIdDiv>
                )}
            </ContactFlex>
          </TopFlex>
          <TopRightFlex row spaceBetween centerVertically>
            <Flex row centerVertically>
              {/* {singleRoleData?.isRankingActive && (
              <TestDetailsFlex column>
                <RatingsDiv>
                  {Number(candidateInfoData?.rating)?.toFixed(2)}
                  <YellowStartSpan>
                    <YellowStartIcon />
                  </YellowStartSpan>
                </RatingsDiv>
                <RatingText>RATINGS</RatingText>
              </TestDetailsFlex>
            )} */}

              <TestFlex column>
                <RatingsDiv>{candidateInfoData?.stage?.toLowerCase()}</RatingsDiv>
                <RatingText>Stage</RatingText>
              </TestFlex>
            </Flex>
            <ThreeDotsDiv>
              <Main>
                <DropDown menu={{ items }} trigger={['click']}>
                  <DropBtn>
                    <VerticalThreeDots />
                  </DropBtn>
                </DropDown>
              </Main>
            </ThreeDotsDiv>
          </TopRightFlex>
        </Flex>
        <Flex row centerVertically>
          {aiMatch && (
          <AIMatchWrapper>
            <ScoreBox isRejected={(aiMatch.overall_score || 0) < 2.5}>
              <Score>{aiMatch.overall_score ?? '—'}</Score>
              <ScoreLabel>Star AI Match</ScoreLabel>
              {/* <Stars>{'★'.repeat(aiMatch.star_rating || 0)}{'☆'.repeat(5 - (aiMatch.star_rating || 0))}</Stars> */}
              <Rate
                disabled
                allowHalf
                value={aiMatch.overall_score || 0}
                style={{ fontSize: 10, color: '#EF9F14' }} // gold color like Figma
              />
            </ScoreBox>

            <MatchContent>
              <MatchText>
                {aiMatch.match_summary || 'Based on CV, assessments, and alignment with role requirements'}
              </MatchText>

              <CriteriaRow>
                <b>{aiMatch.criteria_matched ?? 0} / {aiMatch.criteria_total ?? 0}</b> Criteria match
                <InfoWrapper
                  onMouseEnter={() => setShowInfo(true)}
                  onMouseLeave={() => setShowInfo(false)}
                >
                  <InfoIcon>i</InfoIcon>

                  {showInfo && <InfoTooltip />}
                </InfoWrapper>
              </CriteriaRow>
            </MatchContent>
          </AIMatchWrapper>
          )}
          {stage !== 'all_candidates' && stage !== 'offer' && (
          <SplitButtonWrapper>
            <Button.Secondary
              loading={isUpdating}
              onClick={handleMainAction}
              text={selectedAction === 'shortlist' ? 'Shortlist' : 'Reject'}
              disabled={isActionDisabled()}
            />
            <Dropdown
              menu={shortlistItems}
              trigger={['click']}
              disabled={isShortlistDisabled() && isRejectDisabled()}
            >
              <Button.Secondary
                disabled={isUpdating || (isShortlistDisabled() && isRejectDisabled())}
                icon={<DownArrowSolid />}
              />
            </Dropdown>
          </SplitButtonWrapper>
          )}
        </Flex>
      </HeaderFlex>
    )
  }
  const content = () => {
    return (
      <div>
        <StyledTab defaultActiveKey={candidateInfoData?.aiMatchScore ? "3" : candidateInfoData?.responseData ? "4" : "1"}>
          {candidateInfoData?.aiMatchScore && (
            <TabPane tab={<>AI Profile Summary</>} key="3">
              <AIProfileSummaryTab aiMatch={candidateInfoData?.aiMatchScore} />
            </TabPane>
          )}
          {candidateInfoData?.responseData && (
            <TabPane tab={<>Responses</>} key="4">
              <ResponsesTab
                responseData={candidateInfoData?.responseData}
                applicationFormTemplate={singleRoleData?.applicationFormTemplate}
              />
            </TabPane>
          )}
          <TabPane tab={<>Interview</>} key="1">
            <RoundsSteps
              candidateInfo={candidateInfo}
              setCandidateInfo={setCandidateInfo}
              scheduleDrawer={scheduleDrawer}
              setScheduleDrawer={setScheduleDrawer}
              rolesMetrics={rolesMetrics}
              candidateInterviewDetails={candidateInterviewDetails}
              candidateInfoData={candidateInfoData}
              updateInterviewStatus={updateInterviewStatus}
              driveId={driveId}
              roleId={roleId}
              getCandidateList={getCandidateList}
              selectedRoundType={selectedRoundType}
              getRoleMetrics={getRoleMetrics}
              setSelectedCandidate={setSelectedCandidate}
              setSelectedCandidateId={setSelectedCandidateId}
              getSingleCandidateInterviewDetails={
                getSingleCandidateInterviewDetails
              }
            />
          </TabPane>
          <TabPane tab={<>Resume</>} key="2">
            {/* The uploaded CV only — a candidate with no upload reads as
                "No resume found" rather than a resume we generated. */}
            <ResumePreview
              cvUrl={uploadedCvUrl}
              studentId={candidateDetails?.id}
              roleId={roleId}
              candidateName={candidateFullName}
            />
          </TabPane>
        </StyledTab>
      </div>
    )
  }
  return (
    <Drawer
      width="65%"
      title={title()}
      placement="right"
      padding="0 30px 30px 30px"
      visible={candidateInfo}
      content={content()}
      destroyOnClose={true}
      onClose={() => {
        setCandidateInfo(false)
        setSelectedCandidate([])
        setSelectedCandidateId([])
      }}
    />
  )
}

export default CandidateInfo
